import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatSnackBarRef } from '@angular/material/snack-bar';
import { NotificationModel } from '@shared/services/notifications/notifications.model';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-version-notification',
  templateUrl: './app-version-notification.component.html',
  styleUrls: ['./app-version-notification.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIconModule, MatButtonModule, TranslateModule],
})
export class AppVersionNotificationComponent {
  private readonly _snackBar = inject<MatSnackBarRef<NotificationModel>>(MatSnackBarRef);

  public close() {
    this._snackBar.dismiss();
  }

  public reloadPage() {
    window.location.reload();
  }
}
